import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class InitiativeCard extends Component {
  @service initiativeSlideover;
  @service store;

  @tracked _initiative = {};

  defaultFields = {
    uncertainties: false,
    waiting: false,
    effort: false,
    updatedAt: false,
    tickets: false,
  };

  get initiative() {
    if (this.args.async === true) return this._initiative;
    return this.args.initiative;
  }

  get fields() {
    return this.args.fields ?? this.defaultFields;
  }

  @action
  loadInitiativeIfAsync() {
    if (this.args.async !== true) return;
    this.store
      .findRecord('initiative', this.args.initiative.id, { reload: true })
      .then((initiative) => {
        this._initiative = initiative;
      })
      .catch((error) => {
        console.error('Error loading initiative:', error);
      });
  }

  @action
  openSlideover(initiative_id) {
    this.initiativeSlideover.open(initiative_id);
  }
}
